// extracted by mini-css-extract-plugin
module.exports = {"t1j0ivmq":"t1j0ivmq","tcyd78g":"tcyd78g"};